import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterCarsLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Products & services',
            subNav: [
                {
                    url: '/cars/valuation',
                    displayText: 'Car valuations',
                    routerLink: false,
                },
                {
                    url: '/cars/sell-my-car',
                    displayText: 'Sell my car',
                    routerLink: false,
                },
                {
                    url: '/cars/vehicle-check',
                    displayText: 'Vehicle check',
                    routerLink: false,
                },
                {
                    url: '/cars/finance',
                    displayText: 'Car finance',
                    routerLink: false,
                },
                {
                    url: '/cars/insurance',
                    displayText: 'Car insurance',
                    routerLink: false,
                },
                {
                    url: '/part-exchange',
                    displayText: 'Part exchange',
                    routerLink: false,
                },
                {
                    url: '/cars/finance/calculator',
                    displayText: 'Finance calculator',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Buying advice',
            subNav: [
                {
                    url: '/content/advice',
                    displayText: 'Buying & selling guides',
                    routerLink: false,
                },
                {
                    url: '/retailer-awards',
                    displayText: 'Retailer awards',
                    routerLink: false,
                },
                {
                    url: '/cars/new/awards',
                    displayText: 'New car awards',
                    routerLink: false,
                },
                {
                    url: '/why',
                    displayText: 'Why Autotrader?',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/cars/brands',
                    displayText: 'Car brands',
                    routerLink: false,
                },
                {
                    url: '/cars/uk',
                    displayText: 'All UK locations',
                    routerLink: false,
                },
                {
                    url: '/car-dealers',
                    displayText: 'Find a car dealer',
                    routerLink: false,
                },
                {
                    url: '/cars/leasing/electric',
                    displayText: 'Electric car leasing',
                    routerLink: false,
                },
                {
                    url: '/cars/classic',
                    displayText: 'Classic cars',
                    routerLink: false,
                },
                {
                    url: '/cars/cheap',
                    displayText: 'Cheap cars',
                    routerLink: false,
                },
                {
                    url: '/cars/deals',
                    displayText: 'New car deals',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterCarsLinks;
